export const componentTypes = [
  { label: '文本框', value: 'INPUT' },
  { label: '多行文本', value: 'TEXTAREA' },
  { label: '日期时间', value: 'DATETIME' },
  { label: '数字输入', value: 'NUMBER' },
  { label: '多选框', value: 'SELECT_MANY' },
  { label: '单选下拉框', value: 'SELECT_ONE' },
  { label: '单选按钮', value: 'RADIO' },
  { label: '开关', value: 'SWITCH' },
];

export const businessTypes = [{ label: '会议', value: '1' }];

export const PLATFORMS = [
  { label: '小程序+H5', value: 1 },
  { label: 'PC/Web', value: 2 },
  { label: '小程序', value: 3 },
  { label: 'H5', value: 4 },
];

export const layoutTypes = [
  { label: '新增表单', value: 1 },
  { label: '编辑表单', value: 2 },
  { label: '详情', value: 3 },
];
